//@ts-check
var loadedScript = {};
// var _onerror = false;

export function loadScript(url, callback) {

    if (loadedScript[url]) {
        return callback(null);
    }

    var script = document.createElement('script');

    script.src = url;
    script.async = true;

    script.onload = function () {
        loadedScript[url] = true;
        callback(null);
        document.head.removeChild(script);
    };
    script.onerror = function (e) {
        callback(new Error('load script error'));
    };

    document.head.appendChild(script);
}

export function jsonp(url, callback) {

    var cbName = 'webloc' + Date.now();

    var script = document.createElement('script');
    script.src = url.indexOf('?') === -1 ? url + '?callback=' + cbName : url + '&callback=' + cbName;
    script.async = true;
    script.onerror = function () {
        callback(null);
    };
    // if(_onerror === false) {
    //     _onerror = window.onerror;
    // }
    // window.onerror = function (e) {
    //     callback(null);
    //     if (_onerror && isFunction(_onerror)) {
    //         _onerror.apply(window, arguments);
    //     }
    // };

    window[cbName] = function (res) {
        delete window[cbName];
        document.head.removeChild(script);
        callback(res);
    };

    document.head.appendChild(script);
}

export function isMobile(ua) {
    var regex = /mobile|mobi|android|ios|phone/i;
    return regex.test(ua);
}

export function isWeixin(ua) {
    return (/MicroMessenger/.test(ua)
    );
}

export function isDX(ua) {
    return (/XM\//.test(ua)
    );
}
export function isKNB(ua) {
    return (/KNB\//.test(ua)
    );
}
export function isTitans(ua) {
    return (/titans(no)?x/i.test(ua)
    );
}

export function isApp(ua) {
    return (/meituan|dianping/.test(ua)
    );
}

export function isFunction(fn) {
    return typeof fn === 'function';
}

export function isCrawler(ua) {
    var regex = /bot|spider|crawler/i;
    return regex.test(ua);
}
export function getTrack_points() {
    try {
        var track_points = localStorage.getItem('mars-weblog-trackpoints');
        return track_points ? JSON.parse(track_points) : null;
    } catch (e) {}
    return null;
}

// https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie/Simple_document.cookie_framework
export var cookie = {
    getItem: function getItem(sKey) {
        if (!sKey) {
            return null;
        }
        return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
    },
    setItem: function setItem(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
        if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
            return false;
        }
        var sExpires = "";
        if (vEnd) {
            switch (vEnd.constructor) {
                case Number:
                    sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
                    break;
                case String:
                    sExpires = "; expires=" + vEnd;
                    break;
                case Date:
                    sExpires = "; expires=" + vEnd.toUTCString();
                    break;
            }
        }
        document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
        return true;
    }
};

export var getNetwork = function getNetwork() {
    var ua = navigator.userAgent;
    var network = cookie.getItem('network');
    var reg = /NetType\/([a-zA-Z0-9]+)/;
    if (ua && reg.test(ua)) {
        network = ua.match(reg)[1];
    }
    return network;
};